import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { API_URL } from '../constants';
import { IPagedResults } from '../core/interfaces';
import { BaseDataService, DataService } from '../core/services';

@Injectable()
export class IssueRecipientService extends BaseDataService {
    constructor(protected dataService: DataService) {
        super(dataService, API_URL);
    }

    public getIssuesRecipient(siteId: number): Observable<IPagedResults<any>> {
        let url = `IssueRecipient/GetAllRecipients?siteId=${siteId}`;
        return super.getAll<any>(url);
    }

    public get(id: number): Observable<any> {
        let url = `IssueRecipient/Get?id=${id}`;
        return super.getById(url);
    }

    public getIssueRecipientTypes(): Observable<IPagedResults<any>> {
        let url = `IssueRecipient/GetAllTypes`;
        return super.getAll<any>(url);
    }

    public save(data) {
        let url = `IssueRecipient/Save`;
        return super.save<any>(url, data);
    }

    public deleteData(id: number): Observable<IPagedResults<any>> {
        let url = `IssueRecipient/Delete?id=${id}`;
        return super.getAll<any>(url);
    }

}



// WEBPACK FOOTER //
// ./src/app/services/issue-recipient.service.ts